import { FC } from "react";
import { SignInWiget } from "../../widgets/sign-in/SignIn";

interface Props {
  setMaxStep: (num: number) => void;
}

export const SignInPage: FC<Props> = ({ setMaxStep }) => {
  return <SignInWiget setMaxStep={setMaxStep} />;
};
